module.exports = __webpack_public_path__ + "img/5m.87d7484c.jpg";